import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import './login.scss'
import Navbar from '../../components/navbar/navbar'
import api_host from '../../env'
import logo_small from '../../images/logo_large1.png'

const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loginError, setLoginError] = useState(null)

  const isLoginBtnEnabled = () => username.length > 0 && password.length > 0

  const handleUsernameChange = ({ currentTarget }) =>
    setUsername(currentTarget.value)

  const handlePasswordChange = ({ currentTarget }) =>
    setPassword(currentTarget.value)

  const history = useHistory()
  const handleLogin = () => {
    fetch(`${api_host}/signin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username,
        password
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.status && data.status !== 'OK') {
          setLoginError(data.message)
        } else if (
          data &&
          data.status &&
          data.status == 'OK' &&
          data.token.length > 0
        ) {
          sessionStorage.setItem('token', data.token)
          setLoginError(null)
          history.push('/home')
        } else {
          setLoginError('Something went wrong')
        }
      })
      .catch(() => setLoginError('Something went wrong'))
  }
  const isLoggedIn = sessionStorage.getItem('token')
  if (isLoggedIn) {
    history.push('/home')
  }

  return (
    <>
      <div className="maincontainer">
        <div class="container-fluid">
          <div class="row no-gutter">
            <div class="col-md-6 d-none d-md-flex bg-image"></div>
            <div class="col-md-6 whiteside">
              <div class="login d-flex align-items-center py-5">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-auto col-xl-8 mx-auto">
                      <img
                        src={logo_small}
                        alt="CSIO logo"
                        width="200px"
                        height="100px"
                        className="csio-logo"
                        class="display-7 form-group mb-4"
                      />
                      <h3 class="display-6 form-group mb-3">SIGN IN</h3>
                      <div class="form-group mb-3">
                        <input id="username"
                          type="text"
                          placeholder="Username"
                          required=""
                          autofocus=""
                          onChange={handleUsernameChange}
                          class="form-control rounded-pill border-0 shadow-sm px-4 input-login-bar" />
                      </div>
                      <div class="form-group mb-3">
                        <input
                          id="password"
                          type="password"
                          placeholder="Password"
                          required=""
                          onChange={handlePasswordChange}
                          class="form-control rounded-pill border-0 shadow-sm px-4 text-primary input-login-bar" />
                      </div>
                      {loginError && <p className="error">{loginError}</p>}
                      <button
                        type="submit"
                        class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm"
                        onClick={handleLogin} >
                        Sign in
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Login
